export const academicSeo = {
  title: 'Listening - Academic: Text to Speech for Academic Papers ',
  description:
    'Transform your academic routine! Listen to research on the go and create a new study experience. Explore our offerings today!',
};
